import type { AdminOrder, DashboardStats, TopProduct } from '../model/types'

export function getStats(): DashboardStats {
  return {
    orders:    { value:  128, delta: 12.5 },
    revenue:   { value: 892_500_000, delta: 8.3 },
    products:  { value:   24, delta:  0 },
    customers: { value:   96, delta: 15.2 },
  }
}

export function getLast7DaysOrders(): { label: string; value: number }[] {
  const labels = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN']
  const values = [12, 18, 15, 22, 28, 35, 24]
  return labels.map((label, i) => ({ label, value: values[i] }))
}

export function getRecentOrders(): AdminOrder[] {
  return [
    { id: 'XD261104A1B2C', customer: 'Nguyễn Văn An',  phone: '0912345678', total: 17_010_000, status: 'pending',   createdAt: '04/11/2026 09:12', itemCount: 1 },
    { id: 'XD261104B3D4E', customer: 'Trần Thị Bình',  phone: '0923456789', total: 28_950_000, status: 'confirmed', createdAt: '04/11/2026 08:45', itemCount: 2 },
    { id: 'XD261103F5G6H', customer: 'Lê Hoàng Cường', phone: '0934567890', total: 15_210_000, status: 'shipping',  createdAt: '03/11/2026 16:30', itemCount: 1 },
    { id: 'XD261103I7J8K', customer: 'Phạm Minh Dũng', phone: '0945678901', total: 36_900_000, status: 'delivered', createdAt: '03/11/2026 14:20', itemCount: 1 },
    { id: 'XD261103L9M0N', customer: 'Hoàng Thị Em',   phone: '0956789012', total:  5_770_000, status: 'cancelled', createdAt: '03/11/2026 11:05', itemCount: 3 },
  ]
}

export function getTopProducts(): TopProduct[] {
  return [
    { id: 'p1', slug: 'xe-may-dien-alpha-s',    name: 'Xe máy điện Alpha S',    image: 'https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=200&q=80', sold: 48, revenue: 816_480_000 },
    { id: 'p4', slug: 'xe-may-dien-klara-s',    name: 'Xe máy điện Klara S',    image: 'https://images.unsplash.com/photo-1619771914272-e3c1ba17ba4d?w=200&q=80', sold: 32, revenue: 1_040_000_000 },
    { id: 'p12',slug: 'tay-ga-dien-vinfast-theon',name:'VinFast Theon S',       image: 'https://images.unsplash.com/photo-1609630875171-b1321377ee65?w=200&q=80', sold: 18, revenue: 1_006_200_000 },
    { id: 'p7', slug: 'xe-dap-dien-cute-20',    name: 'Xe đạp điện Cute 20 inch', image: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=200&q=80', sold: 56, revenue: 750_960_000 },
    { id: 'p11',slug: 'tay-ga-dien-yadea-g5',   name: 'Xe tay ga điện Yadea G5', image: 'https://images.unsplash.com/photo-1532298229144-0ec0c57515c7?w=200&q=80', sold: 24, revenue: 885_600_000 },
  ]
}
